<template>
  <div class="cell-container">
    <ul class="cell-list scroll cell-editorpick">
      <li v-for="(cell, index) in cellList" :key="'editorPickCell_' + index">
        <a href="#" @click.prevent="goDetail(cell)">
          <div class="cell-img-editorpick">
            <span class="gradation"></span>
            <img
              v-lazy="thumbnail(cell)"
              :alt="altTitle(cell)"
              aria-hidden="true"
            />
          </div>
          <div class="cell-info">
            <div
              v-title-list="{ titleList: cellTitle(cell) }"
              class="cell-title-wrap"
            ></div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { get } from 'lodash'
  import { titleList } from '@/common/directives'
  import {
    selectCell,
    getTitle,
    getDomainWithPrefix,
  } from '@/common/util/common'
  import { IMAGE_WAVVE_COM } from '@/common/constant'

  export default {
    name: 'CellListEditorPick',
    directives: {
      titleList,
    },
    props: {
      cellList: {
        type: Array,
      },
      thumbnailInfo: {
        type: Object,
      },
    },
    methods: {
      thumbnail(cell) {
        // 에디터픽은 기존 사용하던 방식으로 이미지 호출, 도메인만 새로운 이미지 서버 도메인으로 변경
        const IMAGE_WIDTH = '_w480'
        const PC_BLUR_KEY = '_blur1'
        const thumbnailUrl = get(cell, 'thumbnail', '')
          .replace('http://', '')
          .replace('https://', '')
        const imagePath = thumbnailUrl
          .replace('dev-image.cdn.wavve.com', '')
          .replace('qa-image.cdn.wavve.com', '')
          .replace('dev-image.wavve.com', '')
          .replace('qa-image.wavve.com', '')
          .replace('img.wavve.com', '')
          .replace('image.wavve.com', '')
          .replace('image.cdn.wavve.com', '')

        if (imagePath === '') {
          return undefined
        }
        const pathArr = imagePath.split('/')
        const fileNameAndExt = pathArr.pop()
        const [fileName, ext] = fileNameAndExt.split('.')
        const completeFileName = [
          fileName + IMAGE_WIDTH + PC_BLUR_KEY,
          ext,
        ].join('.')
        const blurImagePath = [...pathArr, completeFileName].join('/')
        const imageUrl = `https://${IMAGE_WAVVE_COM}${blurImagePath}`
        return getDomainWithPrefix(imageUrl)
      },
      cellTitle(cell) {
        return get(cell, 'title_list', [])
      },
      goDetail(cell) {
        if (get(cell, 'event_list', []).length === 0) return
        selectCell(cell)
      },
      altTitle(cell) {
        return getTitle(cell)
      },
    },
  }
</script>
